import {
  apiDelete,
  apiGet,
  apiPost,
  apiPut,
} from "./client";
import { getStoredUser, setStoredUser, shouldRememberSession } from "./session";

export async function fetchSubscriptionStatus() {
  const json = await apiGet("/subscription/status");
  const user = getStoredUser() || {};
  setStoredUser({ ...user, ...json }, shouldRememberSession());
  return json;
}

export async function getSubscriptionAvailability() {
  return apiGet("/subscription/availability");
}

export async function validateDiscountCode({ code, months = 1 }) {
  return apiPost("/subscription/discount/validate", { code, months });
}

export async function createSubscriptionCheckoutSession(data) {
  return apiPost("/subscription/checkout-session", data);
}

export async function fetchSubscriptionCheckoutSession(id) {
  return apiGet(`/subscription/checkout-session/${id}`);
}

export async function getSubscriptionSettings() {
  return apiGet("/admin/subscriptions/settings");
}

export async function updateSubscriptionSettings(data) {
  return apiPut("/admin/subscriptions/settings", data);
}

export async function getSubscriptionStudents() {
  return apiGet("/admin/subscriptions/students");
}

export async function getSubscriptionReport(from, to) {
  const params = new URLSearchParams();
  if (from) params.set("from", from);
  if (to) params.set("to", to);
  const query = params.toString() ? `?${params.toString()}` : "";
  return apiGet(`/admin/subscriptions/report${query}`);
}

export async function getCoupons() {
  return apiGet("/admin/subscriptions/coupons");
}

export async function createCoupon(data) {
  return apiPost("/admin/subscriptions/coupons", data);
}

export async function updateCoupon(id, data) {
  return apiPut(`/admin/subscriptions/coupons/${id}`, data);
}

export async function removeCoupon(id) {
  return apiDelete(`/admin/subscriptions/coupons/${id}`);
}

export async function activateAdminStudentSubscription(userId, months = 1) {
  return apiPost(`/admin/subscriptions/subscribe/${userId}`, { months });
}

export async function grantAdminStudentTrial(userId, days = 7) {
  return apiPost(`/admin/subscriptions/trial/${userId}`, { days });
}

export async function cancelAdminStudentSubscription(userId) {
  return apiPost(`/admin/subscriptions/cancel/${userId}`);
}

export async function activateAdminStudentSubscriptionsBulk(studentIds = [], months = 1) {
  return apiPost("/admin/subscriptions/bulk-subscribe", {
    student_ids: Array.isArray(studentIds) ? studentIds : [],
    months,
  });
}

export async function grantAdminStudentsTrialBulk(studentIds = [], days = 7) {
  return apiPost("/admin/subscriptions/bulk-trial", {
    student_ids: Array.isArray(studentIds) ? studentIds : [],
    days,
  });
}
